module.exports = __webpack_public_path__ + "img/dateAndTime.88a426fb.svg";